import React, { useEffect, useState, useContext } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ShopButton from "./ShopButton";
import { useFirestore } from "../firebase/FirestoreContext";
import { collection, getDocs } from "firebase/firestore";
import { EnvContext } from "../context/EnvContext";
import config from "../config";
import { useNavigate } from "react-router-dom";

const breakpoints = [755]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

const FAQ = () => {
  const [faqData, setFaqData] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const db = useFirestore();
  const environment = useContext(EnvContext);
  const collectionPath = environment === "staging" ? config.environment.staging.collectionPath : config.environment.production.collectionPath;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFaqs = async () => {
      if (!db) {
        console.error("Firestore instance is not initialized.");
        return;
      }
      try {
        const faqCollection = collection(db, `${collectionPath}Help/FAQ/DataBase`);
        const faqSnapshot = await getDocs(faqCollection);
        const faqList = faqSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setFaqData(faqList);
      } catch (error) {
        console.error("Error fetching FAQs:", error);
      }
    };

    fetchFaqs();
  }, [db, collectionPath]);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div css={styles.container}>
      <h2 css={styles.title}>FAQs</h2>
      <div css={styles.faqList}>
        {faqData.map((item, index) => (
          <div key={item.id} css={styles.faqItem}>
            <button css={styles.faqQuestion} onClick={() => handleToggle(index)}>
              <span>{item.question}</span>
              {openIndex === index ? <ExpandLessIcon css={styles.icon} /> : <ExpandMoreIcon css={styles.icon} />}
            </button>
            {openIndex === index && (
              <p css={styles.faqAnswer} onClick={() => navigate("/knowledge")}>
                {item.answer}{" "}
                <span css={{ ...styles.learnMore }}>Learn More</span>
              </p>
            )}
          </div>
        ))}
      </div>
      <ShopButton
        text="Visit Our Help Center"
        theme="light"
        outlined
        background={"white"}
        arrow
        onClick={() => navigate("/knowledge")}
        containerStyles={styles.cta.button}
        buttonStyle={styles.cta.text}
      />
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    margin: "0px auto",
    padding: "20px",
    background: "#f8f8f8",
  },
  title: {
    fontSize: "1.4rem",
    fontWeight: 700,
    marginBottom: "10px",
    [mq[0]]: {
      fontSize: "1.6rem",
    },
  },
  faqList: {
    marginBottom: "20px",
  },
  faqItem: {
    padding: "5px 0",
    margin: "10px 0"
  },
  faqQuestion: {
    width: "100%",
    background: "none",
    border: "none",
    fontSize: "1rem",
    fontWeight: "700",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    padding: "5px 0",
    textAlign: "left",
    color: "black",
    [mq[0]]: {
      fontSize: "1.1rem",
    },
  },
  faqAnswer: {
    color: "#555",
    marginTop: "6px",
    [mq[0]]: {
      fontSize: "1.1rem",
    },
  },
  learnMore: {
    color: "black",
    cursor: "pointer",
    textDecoration: "underline",
    fontWeight: 800,
  },
  icon: {
    width: "24px",
    height: "24px",
    [mq[0]]: {
      width: "26px",
      height: "26px",
    },
  },
  cta: {
    button: {
      maxWidth: "380px",
      margin: "10px auto",
    },
    text: {
      fontSize: "1rem",
      lineHeight: "1rem",
      [mq[0]]: {
        fontSize: "1.1rem",
        lineHeight: "1.1rem",
      },
    }
  }
};

export default FAQ;
